<template>
    <p class="control">
        <quill-editor content-type="html" v-model:content="message" :class="{'is-danger': hasError}" :options="editorOptions" @change="change" ref="editor" >
        </quill-editor>
        <form-error :error="error" />
    </p>
</template>

<script>
    import {QuillEditor} from "@vueup/vue-quill";
    export default {
      components: {QuillEditor},
      props: ['value', 'error', 'users', 'hashes'],
        computed: {
            message: {
                get() {
                    return this.value
                },
                set(newValue) {
                    this.$emit('update:input', newValue)
                }
            },
            hasError() {
                return !!this.error
            }
        },
        data() {
            return {
                editorOptions: {
                    modules: {
                        toolbar: [
                            [{ 'font': [] }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            ['clean'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            // [{ 'script': 'sub'}, { 'script': 'super' }],
                            //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            ['link'],
                            ['image'],


                        ],
                    }
                },
            }
        },
        methods: {
            change(editor, html, text) {
            },
            getEditor() {
                return this.$refs.editor
            },
    },
    mounted() {
    }
}
</script>